/*
  v2-cutout-swap.js  (Aug 22 2026 preview)
  The homepage selector renders the live product photos (white ground). This swaps
  each render to its transparent cutout by SKU, so the packs sit seamlessly on the
  flavor plate (matching the pouch band) WITHOUT touching the buy-flow selector code
  or the real product images. Cutouts are hosted Shopify Files. Purely visual.
  Sep 23 2026: whey entries (all but WM60, still held) point at *-cut-2026-09.png, cut from the
  Sep 17 photo-based mains (WC30 = the Sep 19 revision); vegan + WM60 keep the Aug 22 files.
*/
(function () {
  var CUT = {
    "WC15": "https://cdn.shopify.com/s/files/1/0856/6525/1626/files/wc15-cut-2026-09.png?v=1790178981&width=800",
    "WV15": "https://cdn.shopify.com/s/files/1/0856/6525/1626/files/wv15-cut-2026-09.png?v=1790178981&width=800",
    "WCR15": "https://cdn.shopify.com/s/files/1/0856/6525/1626/files/wcr15-cut-2026-09.png?v=1790178981&width=800",
    "WC30": "https://cdn.shopify.com/s/files/1/0856/6525/1626/files/wc30-cut-2026-09.png?v=1790178981&width=800",
    "WV30": "https://cdn.shopify.com/s/files/1/0856/6525/1626/files/wv30-cut-2026-09.png?v=1790178981&width=800",
    "WCR30": "https://cdn.shopify.com/s/files/1/0856/6525/1626/files/wcr30-cut-2026-09.png?v=1790178981&width=800",
    "WM30": "https://cdn.shopify.com/s/files/1/0856/6525/1626/files/wm30-cut-2026-09.png?v=1790178981&width=800",
    "WC60": "https://cdn.shopify.com/s/files/1/0856/6525/1626/files/wc60-cut-2026-09.png?v=1790178981&width=800",
    "WV60": "https://cdn.shopify.com/s/files/1/0856/6525/1626/files/wv60-cut-2026-09.png?v=1790178981&width=800",
    "WCR60": "https://cdn.shopify.com/s/files/1/0856/6525/1626/files/wcr60-cut-2026-09.png?v=1790178981&width=800",
    "WM60": "https://cdn.shopify.com/s/files/1/0856/6525/1626/files/wm60-cut.png?v=1787419707&width=800",
    "VC15": "https://cdn.shopify.com/s/files/1/0856/6525/1626/files/vc15-cut.png?v=1787419708&width=800",
    "VV15": "https://cdn.shopify.com/s/files/1/0856/6525/1626/files/vv15-cut.png?v=1787419708&width=800",
    "VC30": "https://cdn.shopify.com/s/files/1/0856/6525/1626/files/vc30-cut.png?v=1787419708&width=800",
    "VV30": "https://cdn.shopify.com/s/files/1/0856/6525/1626/files/vv30-cut.png?v=1787419708&width=800",
    "VM30": "https://cdn.shopify.com/s/files/1/0856/6525/1626/files/vm30-cut.png?v=1787419708&width=800",
    "VC60": "https://cdn.shopify.com/s/files/1/0856/6525/1626/files/vc60-cut.png?v=1787419708&width=800",
    "VV60": "https://cdn.shopify.com/s/files/1/0856/6525/1626/files/vv60-cut.png?v=1787419707&width=800",
    "VM60": "https://cdn.shopify.com/s/files/1/0856/6525/1626/files/vm60-cut.png?v=1787419708&width=800"
};
  function skuFromUrl(u) {
    var f = (u || '').split('/').pop().split('?')[0];
    var m = f.match(/^([A-Za-z]{2,3}\d{2,3})/);
    return m ? m[1].toUpperCase() : null;
  }
  var img = document.querySelector('.notg-selector__img');
  if (!img) return;
  function fix() {
    // Use the src ATTRIBUTE (the intended source the selector just set), not currentSrc,
    // which lags behind on variant change and would revert the image to the previous pack.
    var src = img.getAttribute('src') || '';
    var sku = skuFromUrl(src);
    if (!sku) return;
    var target = CUT[sku];
    if (target && src !== target) {
      img.removeAttribute('srcset');
      img.src = target;
    }
  }
  new MutationObserver(fix).observe(img, { attributes: true, attributeFilter: ['src', 'srcset'] });
  fix();
})();

/* Statement band copy trial (Aug 22): 4th stat "Scoops, tubs, or mess" -> "Missed days".
   Preview-only text swap so the direction can be reviewed before baking it into the
   homepage template JSON. Runs below the fold, so no visible flash. */
(function () {
  document.querySelectorAll('.notg-stmt__label').forEach(function (l) {
    if (/scoops\s*,?\s*tubs/i.test(l.textContent)) l.textContent = 'Missed days';
  });
})();
